export default{
    'getLoginLogList':'/conference/user/getLoginLogList'
}